module.exports = __webpack_public_path__ + "static/media/superai_symbol_white_sm.312846b3.png";